module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "server-product"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "server-product-main"
  }, [_c('div', {
    staticClass: "tabs-container"
  }, [_c('div', {
    staticClass: "server-message"
  }, [
    [_c('div', {
      ref: "carTransportation",
      staticClass: "server-message-title"
    }, [_c('img', {
      attrs: {
        "src": require("./images/jiaka_.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _vm._m(1)], _vm._v(" "), [_c('div', {
      ref: "declaration",
      staticClass: "server-message-title"
    }, [_c('img', {
      attrs: {
        "src": require("./images/baoguan.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _vm._m(2)], _vm._v(" "), [_c('div', {
      ref: "supervision",
      staticClass: "server-message-title"
    }, [_c('img', {
      attrs: {
        "src": require("./images/jianyan.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _vm._m(3)], _vm._v(" "), [_c('div', {
      ref: "shuzi",
      staticClass: "server-message-title"
    }, [_c('img', {
      attrs: {
        "src": require("./images/shuzi.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _vm._m(4)]
  ], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("./images/tutu.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "server-message-main"
  }, [_c('div', {
    staticClass: "jika"
  }, [_c('p', [_vm._v("\n                运价公开透明，方便客户企业管控物流成本。"), _c('br'), _vm._v("\n                车队规模大，服务大工厂批量用车可一揽子包干，客户省心省力。"), _c('br'), _vm._v("\n                小客户能得到公正对待，基于平时下单数据，旺季有保障。"), _c('br'), _vm._v("\n                拖车运价覆盖全，方便货代客户的销售人员对外报价。"), _c('br'), _vm._v("\n                提供从船公司放单到目的港卸货的全程货物跟踪信息，直观便捷。"), _c('br')]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./images/tu.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "server-message-main"
  }, [_c('p', [_vm._v("\n              鸭嘴兽与头部报关行合作，为货代企业提供代发舱单、拖车报关一站式服务，合作报关行经验丰富，服务有保障，目前已覆盖上海港、宁波港、深圳港、青岛港及太仓港等多个口岸。客户只需上传报关单据至官网，可随时跟踪报关进度，自主打印报关单放行单。\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "advantage"
  }, [_vm._v("特色优势")]), _vm._v(" "), _c('p', [_vm._v("\n              鸭嘴兽将拖车与报关紧密协同，报关与进港无缝衔接，确保时效，全链条跟踪数据，最大化避免由于未完成报关而产生的额外费用，真正让客户省心省力。\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "server-message-main"
  }, [_c('p', [_vm._v("\n              鸭嘴兽专业检验团队成员主要来自检测行业国际知名企业，具有多年丰富从业经验，拥有专业证书。在出口货物出运前/进口货物卸货时，按客户具体要求，对数量、包装、唛头、标识、产品描述及其它特别要求内容进行核查检验，并出具专业报告。\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "advantage"
  }, [_vm._v("特色优势")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("价格优势")]), _vm._v("\n              结合拖车的一体式服务：低协调成本、低路费成本、可微利甚至无利。"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("直观、可控、低风险性")]), _vm._v("\n              客户可以免费通过鸭嘴兽定制摄像头，远程实时查看集装箱装箱现场，随时可暂停、回看、追查等，监装过程直观透明。\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "server-message-main"
  }, [_c('p', [_vm._v("\n              鸭嘴兽基于自身经验积累，围绕集装箱公路运输的相关场景打造数字化协同解决方案，研发了一系列软件产品。\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "product"
  }, [_vm._v("E装卸")]), _vm._v(" "), _c('p', [_vm._v("\n              E装卸车辆预约管理系统是鸭嘴兽为仓库、工厂提供的一整套从车辆装卸预约到运输作业完成整个作业生命周期全流程可视化管理的SaaS平台。提供车辆到场预约、到场排队叫号，库内作业节点反馈，离场送达等全链路可视化管理功能。"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("优势")]), _vm._v("：SaaS化部署，实施周期短，用户投入成本低，有网就能用，上手使用快。\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "product"
  }, [_vm._v("跨境物流助手")]), _vm._v(" "), _c('p', [_vm._v("\n              跨境物流助手是鸭嘴兽基于腾讯企业QQ打造的一款通过提单号，船名、航次一键查询港口数据，船舶计划、箱动态、海放、码放等关键节点信息的数据协同工具，让用户在企业QQ沟通的场景下直接获取相关节点数据，提高沟通效率。\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("优势")]), _vm._v("：基于QQ聊天场景直接提供数据服务，用户无需切换其他网站查询，提高工作效率。节点订阅推送，避免重要节点遗漏，异常节点第一时间提醒。\n            ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1f78773c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f78773c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/views/server-product/server-product.vue
// module id = 2584
// module chunks = 31